import FormatMixin from '@/modules/Application/mixins/FormatMixin';

const { valorUS } = FormatMixin.methods;

const receiverForSave = (receiver) => {
  const { id, remotePersonId, ...rest } = receiver;

  if (remotePersonId) return receiver;

  return {
    ...rest,
    remotePersonId: id,
  };
};

const servicesForSave = (services) => {
  const { serviceCollection } = services;

  const keysToFormat = ['discount', 'price', 'quantity', 'totalPrice'];

  const serializeValues = (service) => {
    const serializedArray = keysToFormat.map((key) => ({
      [key]: valorUS(service[key]),
    }));

    return Object.assign({}, service, ...serializedArray);
  };

  const serializedServiceCollection = serviceCollection.map((e) => serializeValues(e));

  return {
    ...services,
    serviceCollection: serializedServiceCollection,
  };
};

const taxesForSave = (taxes) => {
  const taxesKeys = Object.keys(taxes);
  const taxesValues = Object.values(taxes);

  const serializedTaxesArray = taxesKeys.map((e, idx) => {
    if (typeof taxes[e] === 'string') {
      return {
        [e]: valorUS(taxesValues[idx]),
      };
    }

    return {
      [e]: taxesValues[idx],
    };
  });

  return Object.assign({}, ...serializedTaxesArray);
};

const paymentsForSave = (payments) => {
  const { paymentModeCollection } = payments;

  const serializedPayments = paymentModeCollection.map((payment) => {
    const range = payment.range.map((e) => ({
      ...e,
      value: valorUS(e.value),
    }));

    return {
      ...payment,
      range,
    };
  });

  return { ...payments, paymentModeCollection: serializedPayments };
};

export const serializeNfseForSave = (payload) => ({
  ...payload,
  receiver: receiverForSave(payload.receiver),
  services: servicesForSave(payload.services),
  taxes: taxesForSave(payload.taxes),
  payments: paymentsForSave(payload.payments),
});
